// The one place the API's base URL is defined. `@/api/client` and the
// telemetry transport both read it from here; nothing else may read
// `VITE_API_BASE` (`api-base.guard.test.ts`).
//
// It is a build-time choice, never a runtime one:
//
// - `.env.production` names the native application,
//   `https://batch.shubertads.com/api`, since the D1 exit's cutover
//   (2026-10-10). The retired Worker's host, `https://api.shubertads.com`,
//   answers 410.
// - A value set in the environment wins over the `.env.*` files.
// - `.env.development` and `pnpm dev:native` point it at the native application on
//   the rig, `http://127.0.0.1:8080/api`.
// - The mobile preview (`pnpm dev`, `pnpm dev:mobile`) overrides it with its
//   same-origin `/__local-api` proxy to that application (vite.config.ts).
//
// A trailing slash is dropped so `${API_BASE}/path` never doubles it.
export const API_BASE: string = (import.meta.env.VITE_API_BASE ?? '').replace(/\/$/, '');
